<template>
 <div class="card">
    <div class="card-header">Abonos</div>


 <b-field class="file" v-if="permiso==1">
          <b-upload v-model="file_abono">
            <a class="button is-info">
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </a>
          </b-upload>

          <span class="file-name" v-if="file_abono">{{ file_abono.name }}</span>
        </b-field>
        <div class="card-body">
           <div class="form-group row">
            <label class="col-sm-2 col-form-label">Fecha:</label>
          <i class="fa fa-calendar"></i>
          <datetime
            type="date"
         
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
			zone="America/Cancun"
    value-zone="America/Cancun"
            v-model="abono.fecha"
            :disabled="permiso==2"
          ></datetime>
        </div>
          <div class="form-group row">
              <label class="col-sm-2 col-form-label">Cliente:</label>
            <div class="col-sm-6">
             
          <cool-select
  v-model="abono.cliente"
  :items="lista_clientes"
  item-text="nombre_cliente"
  @focus="clearSelection()"
  @select="verAbonos(abono.cliente.idcliente)">
   
          </cool-select>
            </div>
              <label class="col-sm-2 col-form-label">Abono Quincenal:</label>
      <div class="col-sm-2">
        <input
          type="nombre"
          v-model="abono_quincenal"
          @keyup.enter="onEnter"
          :disabled="permiso==2 || abono.idcliente==0"
          class="form-control"
          placeholder="$"
        >
      </div>
          </div>
           <div class="form-group row">
            <label class="col-sm-2 col-form-label">Saldo:</label>
            <div class="col-sm-4">
              <input type="nombre"  v-model="abono.saldo" :disabled=" permiso==2" @keyup="calcular_saldo_final" class="form-control" placeholder="$">
            </div>
           </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Abono:</label>
            <div class="col-sm-4">
              <input type="number" v-model="abono.abono" @keyup="calcular_saldo_final"  class="form-control" placeholder="$">
            </div>
          </div>
           <div class="form-group row">
            <label class="col-sm-2 col-form-label">Saldo Final:</label>
            <div class="col-sm-4">
            
              <input type="number" v-model="abono.saldo_final" :disabled="idcliente==0"  class="form-control" placeholder="$">
            </div>
          </div>
            <div class="row">
              <div class="col-md-4">
                <button class="btn btn-primary" :disabled="guardando" @click="saveAbono">
                  <i class="fa fa-save"></i>
                  Guardar Abono
                </button>
              </div>
               <div class="col-md-4" v-if="edit">
                <button class="btn btn-danger" @click="cancelarEdicion">
                  <i class="fa fa-times"></i>
                 Cancelar Edición
                </button>
              </div>
            
          </div>
         <br>
          <b>Historial de Pagos</b>
          <div class="table-responsive">
            <table class="table table-striped">
              <tr>
                <th @click="sort('fecha')">Fecha de abono</th>
                <th @click="sort('saldo')">Saldo</th>
                <th @click="sort('abono')">Abono</th>
                <th @click="sort('saldo_final')">Saldo Final</th>
				

				<th>&nbsp;</th>

              </tr>
              <tbody v-if="lista_abonos.length>0">
                <tr v-for="(obj,index) in lista_abonos" :key="index">
                  <td>{{obj.fecha | formatDate}}</td>
                  <td>{{obj.saldo | toMXN}}</td>

                  <td>{{obj.abono|toMXN}}</td>
                  <td>{{obj.saldo_final|toMXN}}</td>

                  <td v-if="obj.iduser==2">V</td>
                  <td v-if="obj.iduser==1">A</td>
                  <td v-if="obj.iduser==null">&nbsp;</td>

                  <td v-if="permiso==1">
					<a v-if="obj.abono==0"
                style="color: blue;cursor:pointer"
                class="fa fa-file-pdf-o"
                @click="verDetalles(obj.idabono)"
                    ></a>
                    <a
                      style="margin-right: 10px; color:blue;cursor:pointer"
                      @click="editAbono(obj.idabono)"
                      class="fa fa-edit"
                    ></a>
                     <a
                style="color: red;cursor:pointer"
                class="fa fa-trash"
                @click="eliminarAbono(obj)"
                    ></a>
					
				
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          </div>
</template>
<script>
import { url } from "../main.js";
import { Datetime } from "vue-datetime";
import { CoolSelect } from 'vue-cool-select';
import moment from 'moment-timezone'



export default {
  data() {
    return {
      edit:false,
      guardando:false,
      enviar:{},
         abono: {
           cliente:{},
        idcliente: 0,
        saldo: "",
        saldo_final: "",
        abono: "",
      fecha:moment().tz("America/Cancun").format()

      },
       lista_abonos: [],
       lista_clientes:[],
        file_abono:null,
      permiso: 0,
      iduser:0,
       idcliente:0,
       abono_quincenal:0
    }
  },
   components: {
    datetime: Datetime,
   CoolSelect

  },
   mounted() {
     console.log(moment().tz("America/Cancun").format())
    this.permiso = localStorage.getItem("permission");
    this.iduser=localStorage.getItem("iduser");
    console.log(this.permiso)
    this.loadClientes();
    //this.verAbonosAll()

   },
   methods:{
        calcular_saldo_final(){
      if(this.abono.saldo!="")
      {
        

  
     this.abono.saldo_final=this.abono.saldo-this.abono.abono;
     if(this.abono.saldo_final<0)
        {
          this.$swal("El saldo final es negativo. Favor de revisar la cantidad que ingresa en el abono.","","warning");
          this.abono.saldo_final=this.lista_abonos[0].saldo_final;
          this.abono.abono="0";
    
      }
      } 
    },
      loadClientes() {
      this.axios
        .get(url + "apiClientes.php/get_clientes")
        .then(respuesta => {
          console.log(respuesta);
          this.lista_clientes = respuesta.data;
         this.lista_clientes.forEach(element => {
           element.nombre_cliente=element.nombre+" "+element.apellido
           
         });

          console.log(this.lista_clientes);
        })
        .catch(function() {
          console.log("FAILURE ver!!");
        });
    },
    saveAbono() {
		this.abono.fecha=  moment(this.abono.fecha).tz("America/Cancun").format("YYYY-MM-DD");
	  console.log(this.abono.fecha);


      if (this.file_abono != null) {
       
        console.log(this.file_abono);
        this.uploadFile_Abonos(this.file_abono);
       
      } else {
        console.log(this.iduser);
        if (this.validarcampos_abono()) {
          console.log(this.iduser);
          if(this.abono.abono=="")
          {
             this.$swal("Ingrese un abono");
            //this.abono.abono=0;
            //this.calcular_saldo_final()
          }else{
          if (this.abono != null) {
            this.abono.iduser=this.iduser
            console.log(this.abono);

 

            this.guardando=true;
            this.axios
              .post(url + "apiClientes.php/save_abono", this.abono)
              .then(respuesta => {
                console.log(respuesta);
              if (respuesta.data.status === 200) {
                  
                  this.$swal(respuesta.data.msg);
               //   this.limpiarcampos_abono();

                  this.verAbonos(this.abono.idcliente);
                  this.edit=false;
                  this.guardando=false;
                }
              })
              .catch(function() {
                console.log("FAILURE!!");
              });
          }
        }
        }
      }
    },verAbonos(idcliente){
      
    this.limpiarcampos_abono();
      this.abono.idcliente=idcliente;
      this.lista_abonos=[];
      /*if(nombre_cliente!="" && nombre_cliente!=null)
      {
     this.nombre_cliente=nombre_cliente
      }
     this.tabIndex=1;*/

     
     this.axios
        .get(url + "apiClientes.php/get_abonos/"+idcliente)
        .then(respuesta => {
          console.log(respuesta);
          this.lista_abonos = respuesta.data;
          this.abono.saldo=this.lista_abonos[0].saldo_final;
        this.abono.saldo_final=this.lista_abonos[0].saldo_final;
        this.abono_quincenal=this.lista_abonos[0].abono_quincenal;
      
      
        this.abono.abono=0;


           
         
         
        })
        .catch(function() {
          console.log("FAILURE ver!!");
        });

    },
    verAbonosAll(){
      this.lista_abonos=[];
 this.axios
        .get(url + "apiClientes.php/get_abonos_all/")
        .then(respuesta => {
          console.log(respuesta);
          this.lista_abonos = respuesta.data;

          console.log(this.lista_abonos);
        })
        .catch(function() {
          console.log("FAILURE ver!!");
        });
    },validarcampos_abono()
     {
        if (
        this.abono.saldo == ""
        // ||
       // this.abono.saldo_final == ""
      ) {
        return false;
      } else {
        return true;
      }
     },
      uploadFile_Abonos(file) {
      var formData = new FormData();
      formData.append("abonos", file);

      this.axios
        .post(
          url + "apiClientes.php/up_abonos",
          formData,

          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(respuesta=> {
          console.log(respuesta);
         console.log(url);
          this.file_abono= null;
          $scope.abono={};
           this.verAbonosAll();

       /*   if(this.idcliente==0)
          {
            this.verAbonosAll();
         
          }else{*/
          //  this.verAbonos(this.idcliente,this.nombre_cliente)
         // }
          
         
        })
        .catch(respuesta=> {
          console.log(respuesta);
        
        });
  },editAbono(idabono){
    this.edit=true;
    this.axios
        .get(url + "apiClientes.php/get_abono/"+idabono)
        .then(respuesta => {
          
          this.abono.idabono=respuesta.data.idabono;
          this.abono.saldo= respuesta.data.saldo;
          this.abono.fecha=respuesta.data.fecha;
          this.abono.abono=respuesta.data.abono;
          this.abono.saldo_final=respuesta.data.saldo_final;
          this.abono.idcliente=respuesta.data.idcliente;
          
        

         
          
         
     
        });
  },eliminarAbono(abono){
  this.$swal({
        title: "Confirmación",
        text: "¿Desea eliminar el abono?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar"
      }).then(result => {
        if (result.value) {
          this.$http
            .post(url + "apiClientes.php/delete_abono",abono)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Abono Eliminado");
                this.verAbonos(abono.idcliente);
              }
            });
        }
      });
  },limpiarcampos_abono(){
    this.abono.idabono=0;
    this.abono.abono="0";
    this.abono.saldo_final="";
    this.abono.saldo="";
    this.abono.fecha=moment().tz("America/Cancun").format();

    
  },
  cancelarEdicion(){
    this.edit=false;
    
    this.abono.fecha=moment().tz("America/Cancun").format();
    this.abono.idabono=0;
       this.abono.saldo=this.lista_abonos[0].saldo_final;
   // this.abono.saldo=this.abono.saldo_final;
   this.abono.abono="0";
    this.calcular_saldo_final();

  },
    onEnter: function() {
      this.enviar.idcliente=this.abono.idcliente;
      this.enviar.abono_quincenal=this.abono_quincenal;
      console.log(this.enviar)
       if(this.abono_quincenal!="")
       {
         this.axios.post(url + "apiClientes.php/abono_quincenal",this.enviar).then(respuesta => {
        
        
      });
       }
    },
	verDetalles(idabono){
	
	window.open("https://alex.hotel-arrecife.com/wsalex/reporte_venta_abono.php?idabono="+idabono, "_blank"); 

     
		
	},
	clearSelection()
	{
		
		this.abono.cliente=null;
		console.log(this.abono.cliente);
	}
   }
}
</script>


// WEBPACK FOOTER //
// src/views/abonos.vue